import { render, staticRenderFns } from "./ModalPackageQuantities.vue?vue&type=template&id=023b65f9&scoped=true&lang=pug"
import script from "./ModalPackageQuantities.vue?vue&type=script&lang=js"
export * from "./ModalPackageQuantities.vue?vue&type=script&lang=js"
import style0 from "./ModalPackageQuantities.vue?vue&type=style&index=0&id=023b65f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b65f9",
  null
  
)

export default component.exports